<template>
  <div class="row-v2">
    <div class="col">
      <div class="col__box">
        <loading-component v-if="movies == null" />
        <template v-else>
          <div>
            Tìm thấy <strong>{{movies.total}}</strong> kết quả.
          </div>
          <div>
            <movie-item-vertical-component v-for="movie in movies.data" v-bind:movie="movie" :key="movie.slug" />
          </div>
          <div class="text-center">
            <paginate-component v-bind="movies" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
'use strict';
export default {
  name: 'search-index',
  data() {
    return {
      movies: null,
    };
  },
  watch: {
    $route() {
      this.search();
    },
  },
  methods: {
    search() {
      window.api.search.get(this.$route.query)
        .then((res) => {
          window.Vue.set(this, 'movies', res);
        });
    }
  },
  created() {
    this.search();
  }
};

</script>
